export function createTableRangeObject() {
    return {
        name_public: "",
        name_private: "",
    };
};

export function createPreferencesObject() {
    return {
        preference_name: ""
    };
}

export interface VenueLink {
    url: string;
    label: string;
}

export type VenueLinks = Record<string, VenueLink>;

export function createURLLinkObject() {
    const link: VenueLink = {
        url: "",
        label: ""
    }

    return link;
}